import { Reveal } from "./Reveal";

export default function SectionLabel({ children, tone = "dark", id }) {
    const line =
        tone === "light" ? "bg-[#1a1914]/25" : "bg-gold/40";
    const text = tone === "light" ? "text-[#8a6d28]" : "text-gold";
    return (
        <Reveal
            data-testid={`section-label-${id}`}
            className="flex items-center justify-center gap-5 md:justify-start"
        >
            <span className={`h-px w-12 sm:w-20 ${line}`} aria-hidden="true" />
            <span
                className={`font-label text-[11px] uppercase tracking-[0.5em] ${text}`}
            >
                {children}
            </span>
            <span className={`h-px w-12 sm:w-20 ${line}`} aria-hidden="true" />
        </Reveal>
    );
}
